import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const init = () => {
  ScrollTrigger.normalizeScroll({
    allowNestedScroll: true,
    lockAxis: false,
    type: "touch,wheel,pointer",
  });

  const fadeIn = document.querySelectorAll('.js-fadeIn');

  fadeIn.forEach((elm) => {
    gsap.to(elm, {
      y: 0,
      opacity: 1,
      duration: 0.4,
      ease: "sine",
      scrollTrigger: {
        trigger: elm,
        start: "top 80%",
      },
    });
  });

  // 画面をリサイズ・回転したときにScrollTriggerを更新
  window.addEventListener('resize', () => {
    ScrollTrigger.refresh();
  });
  window.addEventListener('orientationchange', () => {
    ScrollTrigger.refresh();
  });
  
}

export {
    init,
};